<template>
    <div>
        <div class="container py-4 simulator">

            <a class="return" @click="getView">&lt; Regresar</a>

            <h2>Tu Simulador</h2>
            <p>Es una herramienta de ayuda, que no tiene en cuenta los datos de cartera, por lo tanto, el resultado final puede cambiar.</p>
            <!-- Disclaimer Renta Variable  inicio-->
            <div class="d-none d-md-block">
                <div class="fixed-bottom w-50 row mx-auto">
                    <div class="bg-white shadow-lg p-2 m-2 m-md-0 my-md-2 text-bat rounded-4">
                        <div class="row d-flex align-items-center justify-content-center">
                            <div class="col-2 d-flex align-items-center justify-content-end">
                                <img src="/img-version2/icons/atention-msg.svg" alt="">
                            </div>
                            <div class="col-8">
                                <p class="fw-bold mb-0 text-break fs-7 text-center">Este seguimiento de la renta variable es una herramienta de apoyo, <br> <span class="text-danger text-title-bat">no implica ningún compromiso de pago por parte de BAT</span></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Disclaimer Renta Variable  Final-->
            <!-- Disclaimer Renta Variable Mobile inicio-->
            <div class="d-block d-md-none">
                <div class="bg-white shadow-lg fixed-top p-2 m-2 text-bat rounded-4" v-show="showDiv">
                    <div class="row d-flex align-items-center justify-content-center">
                        <div class="col-2 d-flex align-items-center justify-content-center">
                            <img src="/img-version2/icons/atention-msg.svg" alt="">
                        </div>
                        <div class="col-10">
                            <p class="fw-bold mb-0 text-break fs-7">Este seguimiento de la renta variable es una herramienta de apoyo, <span class="text-danger text-title-bat">no implica ningún compromiso de pago por parte de BAT</span></p>
                        </div>
                    </div>
                </div>
            </div>





            <div v-if="showModalVariable">
                <popups-variable-rent :closeModalRentVariable="closeModalRentVariable" :accelerators="accelerators"></popups-variable-rent>
            </div>

            <!-- Nuevas tabs -->
            <div v-if="isGrouped">

                <div v-if="hasValidRvData()">
                    <span class="text-bat">*El volumen o el número de pedidos puede variar de acuerdo con el procedimiento de las devoluciones.</span>
                    <h5 class="text-indigo-darkness text-title-bat mt-5">Seguimiento de Variables</h5>
                    <div class="check-var d-flex align-self-start d-flex align-items-start mt-3 text-bat">

                        <div class="mb-4">
                            <a class="link-explanatory-popup text-bat" @click="showModalRentVariable">
                                <img src="/img-version2/icons/activity.svg" alt="Icono">
                                <span class="reference">Encuentra aquí las variables aceleradoras</span>
                            </a>
                        </div>
                    </div>

                    <div class="tabs-channels col-md-6 mb-3">
                        <button
                            class="tab"
                            :class="{ active: activeTab === 'WHS' }"
                            @click="activeTab = 'WHS'"
                        >
                            WHS
                        </button>
                        <button
                            class="tab"
                            :class="{ active: activeTab === 'RETAIL' }"
                            @click="activeTab = 'RETAIL'"
                        >
                            RETAIL
                        </button>
                    </div>

                    <metrics-rv-simulator v-if="data_rv_ready"
                        :data_rv_sim="data_rv_sim"
                        :isGrouped="isGrouped"
                        :activeTab="activeTab"
                        :segment_display_rv="segment_display_rv"
                        :accelerators="accelerators"
                        :payments_rv="payments_rv"
                    ></metrics-rv-simulator>
                </div>
                <div v-else class="msj-error mt-4">
                    <div class="content d-flex align-items-start p-2">
                        <p class="mb-0"> Por cambio en la estructura del modelo de <strong>renta variable</strong>, no es posible ver el histórico de meses anteriores en la plataforma.</p>
                    </div>
                </div>
            </div>
            <div v-else>
                <div v-if="hasValidRvData()">
                    <metrics-rv-simulator v-if="data_rv_ready"
                        :data_rv_sim="data_rv_sim"
                        :isGrouped="isGrouped"
                        :activeTab="activeTab"
                        :segment_display_rv="segment_display_rv"
                        :accelerators="accelerators"
                        :payments_rv="payments_rv"
                    ></metrics-rv-simulator>
                </div>
                <div v-else class="msj-error mt-4">
                    <div class="content d-flex align-items-start p-2">
                        <p class="mb-0"> No se ha cargado información de <strong>renta variable</strong> para el mes en curso.</p>
                    </div>
                </div>
            </div>
        </div>

        <!-- Mensaje de Comodin Inicio -->
        <el-dialog
            :visible.sync="comodinModal"
            :width="$mq ==='sm' ? '90%' : '30%'"
            :show-close="false"
            top="5vh"
            custom-class="bg-info bg-gradient rounded-3 border-bottom border-primary border-4"
            >
            <div class="d-flex justify-content-evenly align-items-center">
                <img src="/img-version2/icons/comodin-modal.svg" alt="">
                <span class="text-break text-center ms-md-3 text-dark fs-5 text-bat">
                    Acabas de desbloquear tú
                    <strong>
                        candado de cartera
                    </strong>
                </span>
            </div>
        </el-dialog>
        <!-- Mensaje de Comodin Final -->

        <div class="modal fade modal-conversion" id="tableModalSimulator" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Tabla de equivalentes</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">Cerrar</button>
                    </div>
                    <div class="modal-body">
                        <table v-if="payments_rv" class="table table-conversion table-bordered align-center">
                            <thead>
                                <tr class="header">
                                <th scope="col">Sumatoria</th>
                                <th scope="col">Pago R.V.</th>
                                </tr>
                            </thead>
                            <tbody>
                                <!-- Fila adicional para "Menor al primer cumplimiento" con 0% -->
                                <tr>
                                    <td scope="row">Menor a {{ payments_rv[0].accomplishment }}%</td>
                                    <td>0%</td>
                                </tr>
                                <!-- Resto de las filas -->
                                <tr v-for="(payment, index) in payments_rv" :key="index">
                                    <td scope="row">
                                        {{ index === payments_rv.length - 1 ? `Mayor a ${payment.accomplishment}%` :
                                            `${payment.accomplishment}%`
                                        }}
                                    </td>
                                    <td>{{ payment.rv_payment }}%</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    props: {
        data_rv: {
            default: [],
        },
        segment_display_rv: {
            default: null,
        },
        accelerators: {
            default: null,
        },
        payments_rv: {
            default: null,
        },
    },
    data() {
        return {
            data_rv_ready: false,

            data_rv_sim: [],
            selected_block: null,
            view: 'seller',

            rv_accomplishment: 0,
            award: 0,
            state_collection: '',
            state_message: '',
            final_accomplishment: 0,
            rv_result: 0,

            show_metrics: true,
            pending_accountant: 0,
            check: false,
            showDiv: false,
            comodinModal: false,

            showModalVariable: false,
            showModalPopupsWildcard: false,

            total_award: 0,
            total_expected: 0,

            activeTab: 'WHS',
            isGrouped: false,
        }
    },
    mounted () {
        // window.addEventListener('scroll', this.handleScroll);
    },
    beforeUpdate() {
        this.updateProgressFinalRV();
    },
    watch: {
        data_rv: {
            deep: true,
            handler(new_data_rv, old_data_rv) {
                this.data_rv_ready = true
                this.calculateTotalAward()
                this.data_rv_sim = JSON.parse(JSON.stringify(this.data_rv))
                this.calculateAccomplishment()
                this.calculateFinalAccomplishment()
                this.calculateResult()
            }
        },
        data_rv_sim: {
            deep: true,
            handler(new_data_rv, old_data_rv) {
                this.calculateTotalAward()
                this.updateCollection()
                this.isGroupedByChannel()
            }
        },
        rv_result: function() {
            this.updateProgressFinalRV()
        },
        pending_accountant: function() {
            this.updateProgressFinalRV()
        },
        rv_accomplishment: function() {
            this.calculateResult()
        },
    },
    methods: {
        hasValidRvData() {
            if(this.isGrouped) {
                return this.data_rv && this.data_rv.metrics && Object.keys(this.data_rv.metrics).length > 1
            } else {
                return this.data_rv && this.data_rv.metrics && this.data_rv.metrics.length > 0
            }
        },
        isGroupedByChannel() {
            // Verifica si `metrics` es un objeto con claves representando los canales
            this.isGrouped = typeof this.data_rv_sim.metrics === 'object' &&
                                !Array.isArray(this.data_rv_sim.metrics) &&
                                Object.keys(this.data_rv_sim.metrics).length > 0 &&
                                Object.values(this.data_rv_sim.metrics).every(item => Array.isArray(item));
        },
        activeComodin(value1, value2){
            if(Number(this.data_rv_sim.metrics_totals.advance_collection) >= 0.8) {
                this.comodinModal = true;
                setTimeout(() => {
                    this.comodinModal = false;
                }, 2000);
            }
        },
        activeComodin: function(item, event){
            item.age = event.target.value;  // Actual assignment

            if(Number(this.data_rv_sim.metrics_totals.advance_collection) >= 0.8) {
                this.comodinModal = true;
                setTimeout(() => {
                    this.comodinModal = false;
                }, 2000);
            }
        },
        // handleScroll() {
        //     const element = this.$refs.targetElement;
        //     if (element) {
        //         // Obtener la posición del elemento específico
        //         const targetElementPosition = this.$refs.targetElement.offsetTop;

        //         // Obtener la posición actual de desplazamiento vertical
        //         const scrollPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;

        //         // Verificar si la posición de desplazamiento alcanza el elemento específico
        //         if (scrollPosition >= targetElementPosition) {
        //             this.showDiv = true;
        //         } else {
        //             this.showDiv = false;
        //         }
        //     }
        // },
        getTypeVariable(cadena) {
            if(cadena.includes('$')) {
                return true;
            } else {
                return false;
            }
        },
        getView() {
            this.$emit('getView', this.view)
            window.scrollTo(0, 0);
        },
        restoreData() {
            this.data_rv_sim = JSON.parse(JSON.stringify(this.data_rv))

            this.calculateAccomplishment()
            this.calculateFinalAccomplishment()
            this.calculateResult()
        },
        updateCollection() {
            this.data_rv_sim.metrics_totals.advance_collection = Math.round(Number(this.data_rv_sim.metrics_totals.real_collection)) / Math.round(Number(this.data_rv_sim.metrics_totals.goal_collection))
            if((Number(this.data_rv_sim.metrics_totals.goal_collection)) - Number(this.data_rv_sim.metrics_totals.real_collection) <= 0) {
                this.data_rv_sim.metrics_totals.pending_collection = 0
            } else {
                this.data_rv_sim.metrics_totals.pending_collection = (Number(this.data_rv_sim.metrics_totals.goal_collection)) - Number(this.data_rv_sim.metrics_totals.real_collection)
            }
        },
        calculatePendiente(item) {
            // Variable para actualizar velocimetro
            this.pending_accountant = 0

            let pendiente = 0
            if(item.accelerator === 1) {
                if((Number(item.goal) * 1.1) - Number(item.real) <= 0) {
                    pendiente = 0
                } else {
                    pendiente = (Number(item.goal) * 1.1) - Number(item.real)
                }
            } else {
                if((Number(item.goal)) - Number(item.real) <= 0) {
                    pendiente = 0
                } else {
                    pendiente = (Number(item.goal)) - Number(item.real)
                }
            }

            this.pending_accountant = 1

            return Math.round(pendiente)
        },
        approximatelyEqual(a, b) {
            let tolerance = 1e-4
            if(Math.abs(a - b) < tolerance) {
                return a;
            }
            return b;
        },
        calculateAccomplishment() {
            if(this.data_rv_sim && this.data_rv_sim.metrics) {
                if(this.data_rv_sim.metrics && this.data_rv_sim.metrics.length > 0) {
                    let acc_rv = 0
                    this.data_rv_sim.metrics.forEach(function(element) {
                        acc_rv += Number(element.peso) * Number(element.advance)
                    }, acc_rv);
                    this.data_rv_sim.metrics_totals.accomplishment = this.approximatelyEqual(Math.round(acc_rv), acc_rv)
                }
            }
        },
        calculateTotalAward() {
            let totalAward = 0;
            let totalAwardExpected = 0;
            if(this.data_rv_sim.metrics_awards) {
                for (let i = 0; i < this.data_rv_sim.metrics_awards.length; i++) {
                    if(this.data_rv_sim.metrics_awards[i].value && Number(this.data_rv_sim.metrics_awards[i].advance) >= 1 ) {
                        totalAward += Number(this.data_rv_sim.metrics_awards[i].value);
                    }
                    totalAwardExpected += Number(this.data_rv_sim.metrics_awards[i].value);
                }
            }
            this.total_award = totalAward;
            this.total_expected = totalAwardExpected;
        },
        calculateFinalAccomplishment() {
            this.calculateTotalAward()
            if(this.data_rv_sim && this.data_rv_sim.metrics_totals && this.data_rv_sim.metrics_totals.accomplishment) {
                this.final_accomplishment = (Number(this.data_rv_sim.metrics_totals.accomplishment) * 100) + (Number(this.total_award) * 100)
            }

            if(this.data_rv_sim && this.data_rv_sim.metrics_totals && Number(this.data_rv_sim.metrics_totals.advance_collection) < Number(this.data_rv_sim.metrics_totals.target_threshold)) {
                this.state_collection = 'red-semaforo'
                this.state_message = 'msj-semaforo-red'
                // this.state_message_channels = 'msj-semaforo-red-channels'
            } else {
                this.state_collection = 'green-semaforo'
                this.state_message = 'msj-semaforo-green'
            }
        },
        calculateResult() {
            let acc_rv = this.final_accomplishment

            if(acc_rv >= -999 && acc_rv < 90) {
                this.rv_result = 0
            } else if (acc_rv >= 90 && acc_rv < 91) {
                this.rv_result = 50
            } else if (acc_rv >= 91 && acc_rv < 92) {
                this.rv_result = 55
            } else if (acc_rv >= 92 && acc_rv < 93) {
                this.rv_result = 60
            } else if (acc_rv >= 93 && acc_rv < 94) {
                this.rv_result = 65
            } else if (acc_rv >= 94 && acc_rv < 95) {
                this.rv_result = 70
            } else if (acc_rv >= 95 && acc_rv < 96) {
                this.rv_result = 75
            } else if (acc_rv >= 96 && acc_rv < 97) {
                this.rv_result = 80
            } else if (acc_rv >= 97 && acc_rv < 98) {
                this.rv_result = 85
            } else if (acc_rv >= 98 && acc_rv < 99) {
                this.rv_result = 90
            } else if (acc_rv >= 99 && acc_rv < 100) {
                this.rv_result = 95
            } else if (acc_rv >= 100 && acc_rv < 101) {
                this.rv_result = 100
            } else if (acc_rv >= 101 && acc_rv < 102) {
                this.rv_result = 110
            } else if (acc_rv >= 102 && acc_rv < 103) {
                this.rv_result = 120
            } else if (acc_rv >= 103 && acc_rv < 104) {
                this.rv_result = 130
            } else if (acc_rv >= 104 && acc_rv < 105) {
                this.rv_result = 140
            } else if (acc_rv >= 105) {
                this.rv_result = 150
            } else {
                //
            }

            if(this.data_rv_sim.metrics_totals && this.data_rv_sim.metrics_totals.advance_collection < Number(this.data_rv_sim.metrics_totals.target_threshold) && this.segment_display_rv && this.segment_display_rv.penalty) {
                this.data_rv_sim.metrics_totals.result_rv = Math.round(Number(this.rv_result) * (1 - (this.segment_display_rv.penalty / 100)))
            } else {
                this.data_rv_sim.metrics_totals.result_rv = Math.round(Number(this.rv_result))
            }

            this.updateProgressFinalRV()
        },
        customColorMethod(percentage) {
            if (percentage >= 100) {
            return 'green';
            } else if (percentage >= 90 && percentage < 100) {
            return 'orange';
            } else {
            return 'red';
            }
        },
        customColorMethodCollection(percentage) {
            if (percentage >= 100) {
                return 'green';
            } else if (this.data_rv_sim && percentage >= (Math.round(Number(this.data_rv_sim.metrics_totals.target_threshold) * 10000) / 100) && percentage < 100) {
                return 'orange';
            } else {
                return 'red';
            }
        },
        customColorMethodRV(advance, accelerator) {
            if (advance < 0.9) {
                return 'red';
            } else if (advance >= 0.9 && advance < 1) {
                return 'orange';
            }

            if (accelerator == 0) {
                if (advance >= 1) {
                    return 'green';
                }
            } else if (accelerator == 1) {
                if (advance >= 1 && advance < (this.accelerators[0].value / 100)) {
                    return 'green';
                } else if (advance >= (this.accelerators[0].value / 100)) {
                    return '#00B5F3';
                }
            } else if (accelerator == 2) {
                if (advance >= 1 && advance < (this.accelerators[1].value / 100)) {
                    return 'green';
                } else if (advance >= (this.accelerators[1].value / 100)) {
                    return '#5A1E85';
                }
            }
        },
        updateVariableData(item) {
            let accomplishment = Number(item.real) / Number(item.goal)
            if(item.accelerator === 2) {
                if(accomplishment > (this.accelerators[1].value / 100)) {
                    item.advance = (this.accelerators[1].value / 100)
                } else {
                    item.advance = accomplishment
                }
            } else if (item.accelerator === 1) {
                if(accomplishment > (this.accelerators[0].value / 100)) {
                    item.advance = (this.accelerators[0].value / 100)
                } else {
                    item.advance = accomplishment
                }
            } else if (item.accelerator === 0) {
                if(accomplishment > 1) {
                    item.advance = 1
                } else {
                    item.advance = accomplishment
                }
            } else {
                //
            }

            this.calculateAccomplishment()
            this.calculateFinalAccomplishment()
            this.calculateResult()
        },
        updateCollectionData() {
            this.calculateAccomplishment()
            this.calculateFinalAccomplishment()
            this.calculateResult()
        },
        updateRealAwardData(item, index) {
            if (this.data_rv_sim.metrics_awards[index].real >= this.data_rv_sim.metrics_awards[index].goal) {
                this.data_rv_sim.metrics_awards[index].advance = 1
            } else {
                this.data_rv_sim.metrics_awards[index].advance = this.data_rv_sim.metrics_awards[index].real / this.data_rv_sim.metrics_awards[index].goal
            }

            this.calculateAccomplishment()
            this.calculateFinalAccomplishment()
            this.calculateResult()
        },
        formatDate(date){
            const newDate = new Date(date)
            return `${newDate.getDate()}/${newDate.getMonth()+1 < 10 ?`0${newDate.getMonth()+1}`: newDate.getMonth()+1 }/${newDate.getFullYear()}`
        },
        updateProgressFinalRV() {
            let numero = this.$refs.numero
            let point = this.$refs.point
            let star = this.$refs.star
            let stop1 = this.$refs.stop1
            let stop2 = this.$refs.stop2

            if(numero) {
                let svgId = this.$refs.circle_simulator
                let numero2 = (parseInt(Math.round(this.data_rv_sim.metrics_totals.result_rv)) *  170) / 150
                svgId.style.transform = `translate(-50% , -50%) rotate(${numero2}deg)`
                point.style.transform = `translate(-50% , -50%) rotate(${numero2}deg)`
                if (parseInt(Math.round(this.data_rv_sim.metrics_totals.result_rv)) <= 0){
                    stop1.setAttribute("stop-color", "#A8A8A8");
                    stop2.setAttribute("stop-color", "#605B63");
                    numero.style.backgroundImage = '-webkit-linear-gradient(180deg, #A8A8A8 0%, #605B63 97.64%)';

                    point.classList.remove("red")
                    point.classList.remove("orange")
                    point.classList.remove("green")
                    point.classList.add("d-none")

                    star.classList.remove("active")
                    star.classList.add("disabled")
                } else if (parseInt(Math.round(this.data_rv_sim.metrics_totals.result_rv)) > 0 && parseInt(Math.round(this.data_rv_sim.metrics_totals.result_rv)) < 50){
                    stop1.setAttribute("stop-color", "#ff9999");
                    stop2.setAttribute("stop-color", "#ff0000");
                    numero.style.backgroundImage = '-webkit-linear-gradient(180deg, #ff9999 0%, #ff0000 97.64%)';

                    point.classList.add("red")
                    point.classList.remove("orange")
                    point.classList.remove("green")
                    point.classList.remove("d-none")

                    star.classList.remove("active")
                    star.classList.add("disabled")
                } else if (parseInt(Math.round(this.data_rv_sim.metrics_totals.result_rv)) >= 50 && parseInt(Math.round(this.data_rv_sim.metrics_totals.result_rv)) < 100){
                    stop1.setAttribute("stop-color", "#FFD600");
                    stop2.setAttribute("stop-color", "#F87C00");
                    numero.style.backgroundImage = '-webkit-linear-gradient(180deg, #FFD600 0%, #F87C00 97.64%)';

                    point.classList.remove("red")
                    point.classList.add("orange")
                    point.classList.remove("green")
                    point.classList.remove("d-none")

                    star.classList.remove("active")
                    star.classList.add("disabled")
                } else if (parseInt(Math.round(this.data_rv_sim.metrics_totals.result_rv)) >= 100){
                    stop1.setAttribute("stop-color", "#6AC11F");
                    stop2.setAttribute("stop-color", "#00660A");
                    numero.style.backgroundImage = '-webkit-linear-gradient(180deg, #6AC11F 0%, #00660A 97.64%)';

                    point.classList.remove("red")
                    point.classList.remove("orange")
                    point.classList.add("green")
                    point.classList.remove("d-none")

                    star.classList.add("active")
                    star.classList.remove("disabled")
                }
            }
        },
        numberFormat(number) {
            const exp = /(\d)(?=(\d{3})+(?!\d))/g
            const rep = '$1,'
            let arr = number.toString().split('.')
            arr[0] = arr[0].replace(exp,rep)
            return arr[1] ? arr.join('.'): arr[0]
        },
        showModalRentVariable() {
            this.showModalVariable = true
        },
        showModalWildcard() {
            this.showModalPopupsWildcard = true
        },
        closeModalRentVariable() {
            this.showModalVariable = false
        },
        closeModalWildcard() {
            this.showModalPopupsWildcard = false
        }
    },
}
</script>
